/* eslint-disable no-unused-vars */
import { h, render, Fragment } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/navigation';
import 'swiper/css';
import clsx from 'clsx';
import Image from '../utils/image';
import IconArrowRight from '../utils/icon/arrow-right.svg';
import IconArrowLeft from '../utils/icon/arrow-left.svg';

export default (element, data) => {
  const init = () => {
    render(<ContentCarousel />, element);
  };

  const getSlidesCount = data.slides.length;

  const setSlidesCountSettings = () => {
    if (getSlidesCount > 1 && getSlidesCount <= 3) {
      const settings = {
        slidesPerView: 'auto',
        slidesOffsetBefore: 40,
        breakpoints: {
          320: {
            navigation: { prevEl: '.prev', nextEl: '.next' },
            slidesPerView: 'auto',
            slidesOffsetBefore: 20,
          },
          1024: {
            slidesPerView: getSlidesCount,
            slidesOffsetBefore: 40,
          },
        },
      };
      return settings;
    }

    return {
      navigation: { prevEl: '.prev', nextEl: '.next' },
      slidesPerView: 'auto',
      slidesOffsetBefore: 40,
      breakpoints: {
        320: {
          navigation: { prevEl: '.prev', nextEl: '.next' },
          slidesPerView: 'auto',
          slidesOffsetBefore: 20,
        },
        1024: {
          navigation: { prevEl: '.prev', nextEl: '.next' },
          slidesPerView: 'auto',
          slidesOffsetBefore: 40,
        },
      },
    };
  };

  const ContentCarousel = () => {
    const slides = setSlidesCountSettings();
    const bambuserElementsRef = useRef(null);

    const getMap = () => {
      if (!bambuserElementsRef.current) bambuserElementsRef.current = new Map();
      return bambuserElementsRef.current;
    };

    useEffect(() => {
      const bambuserTriggerButtons = [...getMap().values()];

      bambuserTriggerButtons.forEach(el => {
        window.initBambuserLiveShopping({
          showId: el.dataset.bambuserShowId,
          node: el,
          type: 'overlay',
        })
      })
    }, []);

    return (
      <>
        <div className="bg-neutral pb-10 laptop:pb-20">
          <div className="relative pt-[45px] laptop:pt-20 pb-4 laptop:pb-5 flex align-center justify-between px-5 laptop:px-10">
            <h3 className="subheading-h2 flex items-center">
              {data.slider_title}
            </h3>
            <div>
              <button className="prev navigation-arrow bg-transparent border border-[#0000004d] rounded-full inline-flex mr-[10px]">
                <IconArrowLeft />
              </button>
              <button className="next navigation-arrow bg-transparent border border-[#0000004d] rounded-full inline-flex">
                <IconArrowRight />
              </button>
            </div>
          </div>
          <div>
            <Swiper modules={[Navigation]} {...slides}>
              {data.slides.map((slide, index) => (
                <SwiperSlide
                  key={slide.id}
                  className={clsx(
                    getSlidesCount <= 2 &&
                      'laptop:w-[calc(50%-40px)!important]',
                    getSlidesCount === 3 &&
                      'laptop:w-[calc(100%/3-40px)!important]',
                    getSlidesCount >= 4 &&
                      'laptop:w-[calc(25%-40px)!important]',
                    'laptop:min-w-[325px!important] w-[325px!important] min-w-[249px!important] laptop:mr-5 mr-[10px] h-[auto!important]',
                  )}
                  style={{ background: slide.background }}
                >
                  <div className="flex flex-col h-full pb-5 relative">
                    {slide.url && !slide.cta_label && (
                      <a
                        href={slide.url}
                        className="absolute inset-0 z-10 link-unstyled"
                      />
                    )}
                    <div className="relative pt-[84.6%] mb-3">
                      <Image
                        src={slide.image}
                        classes="object-cover object-center w-full h-full absolute inset-0"
                      />
                    </div>
                    <div className="subheading-h3 px-3 font-hoefler">{slide.title}</div>
                    <div
                      className="font-14 leading-5 mt-1 px-3 laptop:pt-[2px]"
                      style={{ color: slide.color }}
                    >
                      {slide.overview}
                    </div>
                    {
                      slide.cta_label && (
                        slide.url || slide.bambuser_show_id
                      ) && (
                        <div className="px-3 laptop:pt-[2px] pt-1">
                          {
                            slide.cta_label
                            && slide.url
                            && !slide.bambuser_show_id ? (
                              <a
                                href={slide.url}
                                aria-label={slide.cta_label}
                                className="text-xs underline text-black font-medium leading-3 uppercase font-gotham tracking-[0.02em]"
                              >
                                {slide.cta_label}
                              </a>
                            ) : slide.cta_label && slide.bambuser_show_id ? (
                              <button
                                type="button"
                                aria-label={slide.cta_label}
                                ref={(node) => {
                                  const map = getMap();
                                  if (node) {
                                    map.set(slide.bambuser_show_id, node);
                                  } else map.delete(slide.bambuser_show_id);
                                }}
                                className="text-xs underline text-black font-medium leading-3 uppercase font-gotham tracking-[0.02em]"
                                data-bambuser-show-id={slide.bambuser_show_id}
                              >
                                {slide.cta_label}
                              </button>
                            ) : null
                          }
                        </div>
                      )
                    }
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </>
    );
  };

  init();
};
